<template>
  <el-col :span="7" class="footModule">
    <!-- 快捷入口 -->
    <div class="quickAccess">
      <div class="title">
        当前启动任务 <span class="rotate">{{ openNum }}</span>
      </div>
      <ul>
        <li
          class="item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="handleRouter(item)"
        >
          <img :src="item.img" class="icon-x" alt="" />
          <div>{{ item.name }}</div>
          <div v-if="item.isOpen" class="start-icon">已开启</div>
        </li>
      </ul>
    </div>
  </el-col>
</template>

<script>
import { openState, openSelfState } from "@/api/care/orderCare";
import { versionPermissions } from "@/api/homePage";
export default {
  data() {
    return {
      dataList: [],
      openNum: 0,
      version:{
        accurateMarket: true, //精准营销
        accurateMarketUrl: null,
        autoEvaluation: true, //自动催评
        autoEvaluationUrl: null,
        callCustomerChurn: true,  //流失客户召回
        callCustomerChurnUrl: null,
        conversionUnpurchasedMembers: true, //开卡未购会员转化
        conversionUnpurchasedMembersUrl: null,
        expediting: true, //常规催付
        expeditingUrl: null,
        goodsRepurchase: true, //商品复购
        goodsRepurchaseUrl: null,
        payReminder: true, //付款关怀
        payReminderUrl: null,
        poorEvaluation: true, //中差评安抚
        poorEvaluationUrl: null,
        presaleExpediting: true, //预售尾款催付
        presaleExpeditingUrl: null,
        sendreMind: true, //发货提醒
        sendreMindUrl: null,
        thankEvaluation: true, //好评感谢
        thankEvaluationUrl: null,
        twiceExpediting: true, //二次催付
        twiceExpeditingUrl: null
      },
    };
  },
  computed: {
    venderType() {
       // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    }
  },
  watch: {
    venderType(newval) {
      this.init();
    }
  },
  mounted() {
    // this.getPopState();
    // this.getSelfSupport();
    // this.init();
    this.versionPermissions()
  },
  methods: {
    versionPermissions(){
      versionPermissions().then((res)=>{
        this.version = res.data;
        sessionStorage.setItem('version',JSON.stringify(res.data))
        this.init();
        console.log('98988', this.version);
      })
    },
    init() {
      console.log(this.venderType,'36985214');
      // debugger
      if (this.venderType) {
        this.getSelfSupport()
      } else {
        this.getPopState();
      }
    },
    // 获取pop 版数据
    getPopState() {
      // var abs = JSON.parse(sessionStorage.getItem('version')) ;
      var abs = this.version
      console.log('6369854782',abs);
      // pop 版
      openState().then((res) => {
        var remindSellerConfigData = res.data.remindSellerConfigData;
        var popCommentConfigData = res.data.popCommentConfigData;
        var refundRemindConfigData = res.data.refundRemindConfigData;
        var urlSort = ''
        if (res.code == "1") {
          if(this.venderType){
              urlSort  = '/orderCare/comtCare/poorEvaluationOfficial'
          }else{
              urlSort  = '/orderCare/comtCare/poorEvaluation'
          }
          var dataList = [];
          var obj1 = {
              name: "常规催付",
              img: require("@/assets/images/home/icon_tranf1.png"),
              url:abs.expediting ? "/orderCare/orderCare/expediting":abs.expeditingUrl,
              isOpen: remindSellerConfigData["8"],
            },
            obj2 = {
              name: "二次催付",
              img: require("@/assets/images/home/icon_tranf2.png"),
              url: abs.twiceExpediting ?"/orderCare/orderCare/twiceExpediting":abs.twiceExpeditingUrl,
              isOpen: remindSellerConfigData["12"],
            },
            obj3 = {
              // name: "付款关怀",  旧的
              name: "预售尾款催付",
              img: require("@/assets/images/home/icon_tranf3.png"),
              url: abs.presaleExpediting ?"/orderCare/orderCare/presaleExpediting":abs.presaleExpeditingUrl,
              isOpen: remindSellerConfigData["24"],
            },
            obj4 = {
              // name: "下单关怀（货到）", 旧的
              name: "付款关怀", 
              img: require("@/assets/images/home/icon_tranf4.png"),
              url: abs.payReminder ?"/orderCare/payReminder/payReminder":abs.payReminderUrl,
              isOpen: remindSellerConfigData["1"],
            },
            obj5 = {
              name: "自动催评",
              img: require("@/assets/images/home/icon_tranf5.png"),
              url: abs.autoEvaluation ?"/orderCare/comtCare/autoEvaluation":abs.autoEvaluationUrl,
              isOpen: popCommentConfigData["1"],
            },
            obj6 = {
              name: "发货提醒",
              img: require("@/assets/images/home/icon_tranf6.png"),
              url: abs.sendreMind ?"/orderCare/transreMind/sendreMind":abs.sendreMindUrl,
              isOpen: remindSellerConfigData["2"],
            },
            obj7 = {
              name: "好评感谢",
              img: require("@/assets/images/home/icon_tranf7.png"),
              url: abs.thankEvaluation ?"/orderCare/comtCare/thankEvaluation":abs.thankEvaluationUrl,
              isOpen: popCommentConfigData["2"],
            },
            obj8 = {
              name: "中差评安抚",
              img: require("@/assets/images/home/icon_tranf8.png"),
              url: abs.poorEvaluation ? urlSort:abs.poorEvaluationUrl,
              isOpen: popCommentConfigData["3"],
            };
          dataList.push(obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8);
          console.log("dataList:", dataList);
          this.dataList = dataList;

          // var step = 0;
          // dataList.forEach(item => {
          //   if (item.isOpen) {
          //     step ++;
          //   }
          // })
          // this.openNum = step;

          // 下单催付的所有开启状态
          var step = 0;

          // 下单关怀
          if (remindSellerConfigData["6"]) {
            // 取消提醒
            step++;
          }
          if (remindSellerConfigData["11"]) {
            // 下单关怀（货到)
            step++;
          }
          if (remindSellerConfigData["8"]) {
            // 常规催付
            step++;
          }
          if (remindSellerConfigData["12"]) {
            // 二次催付
            step++;
          }
          if (remindSellerConfigData["24"]) {
            // 预售尾款催付
            step++;
          }

          // 订单关怀
          if (remindSellerConfigData["3"]) {
            // 迟发提醒
            step++;
          }
          if (remindSellerConfigData["1"]) {
            // 付款关怀
            step++;
          }
          if (remindSellerConfigData["2"]) {
            // 发货提醒
            step++;
          }
          if (remindSellerConfigData["13"]) {
            // 派件提醒
            step++;
          }
          if (remindSellerConfigData["14"]) {
            // 签收提醒
            step++;
          }
          if (remindSellerConfigData["5"]) {
            // 回款关怀
            step++;
          }

          // 售后关怀
          if (popCommentConfigData["2"]) {
            // 好评感谢
            step++;
          }
          if (popCommentConfigData["1"]) {
            // 自动催评
            step++;
          }
          if (popCommentConfigData["3"]) {
            // 中差评安抚
            step++;
          }
          if (refundRemindConfigData["3"]) {
            // 拒绝退款
            step++;
          }
          if (remindSellerConfigData["7"]) {
            // 退货提醒
            step++;
          }
          if (refundRemindConfigData["1"]) {
            // 申请退款
            step++;
          }
          if (refundRemindConfigData["2"]) {
            // 同意退款
            step++;
          }
          if (refundRemindConfigData["4"]) {
            // 退款成功
            step++;
          }
          this.openNum = step;
        }
      });
    },
    // 获取自营的数据
    getSelfSupport() {
      //  var absc = JSON.parse(sessionStorage.getItem('version')) ;
       var absc = this.version
      openSelfState().then((res) => {
        // var autoMarketingActivityData = res.data.autoMarketingActivityData;
        var popCommentConfigData = res.data.popCommentConfigData;
        var remindSellerConfigData = res.data.remindSellerConfigData;
        if (res.code == "1") {
          var dataList = [];
          var obj1 = {
              name: "常规催付",
              img: require("@/assets/images/home/pop/pop_1.png"),
              url:absc.expediting ? "/orderCare/orderCare/expediting":absc.expeditingUrl,
              isOpen: remindSellerConfigData["8"],
            },
            obj2 = {
              name: "二次催付",
              img: require("@/assets/images/home/pop/pop_2.png"),
              url: absc.twiceExpediting ?"/orderCare/orderCare/twiceExpediting":absc.twiceExpeditingUrl,
              isOpen: remindSellerConfigData["12"],
            },
            obj3 = {
              name: "预售尾款催付",
              img: require("@/assets/images/home/pop/pop_3.png"),
              url: absc.presaleExpediting ?"/orderCare/orderCare/presaleExpediting":absc.presaleExpeditingUrl,
              isOpen: remindSellerConfigData["24"],
            },
            obj4 = {
              name: "付款关怀",
              img: require("@/assets/images/home/pop/pop_4.png"),
              url:absc.payReminder ?"/orderCare/payReminder/payReminder":absc.payReminderUrl,
              isOpen: remindSellerConfigData["1"],
            },
            obj5 = {
              name: "自动催评",
              img: require("@/assets/images/home/pop/pop_5.png"),
              url: absc.autoEvaluation ?"/orderCare/comtCare/autoEvaluation":absc.autoEvaluationUrl,
              isOpen: popCommentConfigData["1"],
            },
            obj6 = {
              name: "发货提醒",
              img: require("@/assets/images/home/pop/pop_6.png"),
              url: absc.sendreMind ?"/orderCare/transreMind/sendreMind":absc.sendreMindUrl,
              isOpen: remindSellerConfigData["2"],
            },
            obj7 = {
              name: "好评感谢",
              img: require("@/assets/images/home/pop/pop_7.png"),
              url: absc.thankEvaluation ?"/orderCare/comtCare/thankEvaluation":absc.thankEvaluationUrl,
              isOpen: popCommentConfigData["2"],
            },
            obj8 = {
              name: "中差评安抚",
              img: require("@/assets/images/home/pop/pop_8.png"),
              url: absc.poorEvaluation ? '/orderCare/comtCare/poorEvaluationOfficial':absc.poorEvaluationUrl,
              isOpen: popCommentConfigData["3"],
            };
          dataList.push(obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8);
          console.log("dataList:", dataList);
          this.dataList = dataList;         
          this.openNum = res.data.openCount;
        }
      });
    },

    handleRouter(item) {
      console.log(111111111,item);
      // if (item.isOpen) {
      // var url = "/orderCare/orderCare/expediting"
      // var routeUrl = this.$router.resolve({
      //   path: item.url
      // })
      // window.open(routeUrl.href, '_blank');

      // this.bus.$emit("topActive", { index: 2, item: this.$store.state.route[2]});
      this.bus.$emit("topHeader", {
        index: 2,
        item: this.$store.state.route[2],
      });
      this.$router.push({
        path: item.url,
      });
    },

    // }
  },
};
</script>

<style scoped lang="scss">
.rotate {
  color: #fff !important;
  font-size: 10px;
  display: inline-block;
  width: 30px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  vertical-align: middle;
  background-image: url("../../assets/images/home/icon_num.svg");
  background-repeat: no-repeat;
  // background-size: cover;
}
.start-icon {
  color: #fff !important;
  font-size: 10px !important;
  line-height: 16px;
  width: 40px;
  background-image: url("../../assets/images/home/icon_start.svg");
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: calc(50% + 20px);
  transform: translateX(-50%);
}
.footModule {
  .quickAccess {
    display: flex;
    flex-direction: column;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .title {
      flex-shrink: 0;
      box-sizing: border-box;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f6f6f6;
      padding-left: 24px;
      font-size: 16px;
      // font-weight: 800;
      color: #252c38;
    }
    ul {
      flex: 1;
      display: flex;
      flex-flow: wrap;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 24px;
      .item {
        box-sizing: border-box;
        padding: 11px 0;
        position: relative;
        width: 25%;
        height: 100px;
        text-align: center;
        border-radius: 4px;
        transition: all 0.1s;
        cursor: pointer;
        position: relative;
        div {
          color: #333;
          margin-top: 10px;
        }
        .icon-x {
          width: 44px;
          height: 44px;
        }
      }
    }
  }
}
</style>